import * as ambassadorWixMultilingualLocalesV2Locale from './multilingual-locales-v2-locale-locales.http.js';
import * as ambassadorWixMultilingualLocalesV2LocaleTypes from './multilingual-locales-v2-locale-locales.types.js';
import * as ambassadorWixMultilingualLocalesV2LocaleUniversalTypes from './multilingual-locales-v2-locale-locales.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function listSupportedLocales(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixMultilingualLocalesV2LocaleUniversalTypes.ListSupportedLocalesRequest,
  ambassadorWixMultilingualLocalesV2LocaleTypes.ListSupportedLocalesRequest,
  ambassadorWixMultilingualLocalesV2LocaleUniversalTypes.ListSupportedLocalesResponse,
  ambassadorWixMultilingualLocalesV2LocaleTypes.ListSupportedLocalesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMultilingualLocalesV2Locale.listSupportedLocales(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/locales/supported',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createLocale(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMultilingualLocalesV2LocaleUniversalTypes.CreateLocaleRequest,
  ambassadorWixMultilingualLocalesV2LocaleTypes.CreateLocaleRequest,
  ambassadorWixMultilingualLocalesV2LocaleUniversalTypes.CreateLocaleResponse,
  ambassadorWixMultilingualLocalesV2LocaleTypes.CreateLocaleResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMultilingualLocalesV2Locale.createLocale(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/locale',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getLocale(): __PublicMethodMetaInfo<
  'GET',
  { localeId: string },
  ambassadorWixMultilingualLocalesV2LocaleUniversalTypes.GetLocaleRequest,
  ambassadorWixMultilingualLocalesV2LocaleTypes.GetLocaleRequest,
  ambassadorWixMultilingualLocalesV2LocaleUniversalTypes.GetLocaleResponse,
  ambassadorWixMultilingualLocalesV2LocaleTypes.GetLocaleResponse
> {
  const payload = { localeId: ':localeId' } as any;

  const getRequestOptions =
    ambassadorWixMultilingualLocalesV2Locale.getLocale(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/locale/{localeId}',
    pathParams: { localeId: 'localeId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateLocale(): __PublicMethodMetaInfo<
  'PATCH',
  { localeId: string },
  ambassadorWixMultilingualLocalesV2LocaleUniversalTypes.UpdateLocaleRequest,
  ambassadorWixMultilingualLocalesV2LocaleTypes.UpdateLocaleRequest,
  ambassadorWixMultilingualLocalesV2LocaleUniversalTypes.UpdateLocaleResponse,
  ambassadorWixMultilingualLocalesV2LocaleTypes.UpdateLocaleResponse
> {
  const payload = { locale: { id: ':localeId' } } as any;

  const getRequestOptions =
    ambassadorWixMultilingualLocalesV2Locale.updateLocale(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v2/locale/{locale.id}',
    pathParams: { localeId: 'localeId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteLocale(): __PublicMethodMetaInfo<
  'DELETE',
  { localeId: string },
  ambassadorWixMultilingualLocalesV2LocaleUniversalTypes.DeleteLocaleRequest,
  ambassadorWixMultilingualLocalesV2LocaleTypes.DeleteLocaleRequest,
  ambassadorWixMultilingualLocalesV2LocaleUniversalTypes.DeleteLocaleResponse,
  ambassadorWixMultilingualLocalesV2LocaleTypes.DeleteLocaleResponse
> {
  const payload = { localeId: ':localeId' } as any;

  const getRequestOptions =
    ambassadorWixMultilingualLocalesV2Locale.deleteLocale(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v2/locale/{localeId}',
    pathParams: { localeId: 'localeId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryLocales(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixMultilingualLocalesV2LocaleUniversalTypes.QueryLocalesRequest,
  ambassadorWixMultilingualLocalesV2LocaleTypes.QueryLocalesRequest,
  ambassadorWixMultilingualLocalesV2LocaleUniversalTypes.QueryLocalesResponse,
  ambassadorWixMultilingualLocalesV2LocaleTypes.QueryLocalesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMultilingualLocalesV2Locale.queryLocales(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/locale/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateLocales(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMultilingualLocalesV2LocaleUniversalTypes.BulkCreateLocalesRequest,
  ambassadorWixMultilingualLocalesV2LocaleTypes.BulkCreateLocalesRequest,
  ambassadorWixMultilingualLocalesV2LocaleUniversalTypes.BulkCreateLocalesResponse,
  ambassadorWixMultilingualLocalesV2LocaleTypes.BulkCreateLocalesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMultilingualLocalesV2Locale.bulkCreateLocales(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/bulk/locale/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateLocales(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMultilingualLocalesV2LocaleUniversalTypes.BulkUpdateLocalesRequest,
  ambassadorWixMultilingualLocalesV2LocaleTypes.BulkUpdateLocalesRequest,
  ambassadorWixMultilingualLocalesV2LocaleUniversalTypes.BulkUpdateLocalesResponse,
  ambassadorWixMultilingualLocalesV2LocaleTypes.BulkUpdateLocalesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMultilingualLocalesV2Locale.bulkUpdateLocales(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/bulk/locale/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteLocales(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMultilingualLocalesV2LocaleUniversalTypes.BulkDeleteLocalesRequest,
  ambassadorWixMultilingualLocalesV2LocaleTypes.BulkDeleteLocalesRequest,
  ambassadorWixMultilingualLocalesV2LocaleUniversalTypes.BulkDeleteLocalesResponse,
  ambassadorWixMultilingualLocalesV2LocaleTypes.BulkDeleteLocalesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMultilingualLocalesV2Locale.bulkDeleteLocales(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/bulk/locale/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createNewPrimaryLocale(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMultilingualLocalesV2LocaleUniversalTypes.CreateNewPrimaryLocaleRequest,
  ambassadorWixMultilingualLocalesV2LocaleTypes.CreateNewPrimaryLocaleRequest,
  ambassadorWixMultilingualLocalesV2LocaleUniversalTypes.CreateNewPrimaryLocaleResponse,
  ambassadorWixMultilingualLocalesV2LocaleTypes.CreateNewPrimaryLocaleResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMultilingualLocalesV2Locale.createNewPrimaryLocale(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/locale/change-primary',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getNewPrimaryLocaleStatus(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixMultilingualLocalesV2LocaleUniversalTypes.GetNewPrimaryLocaleStatusRequest,
  ambassadorWixMultilingualLocalesV2LocaleTypes.GetNewPrimaryLocaleStatusRequest,
  ambassadorWixMultilingualLocalesV2LocaleUniversalTypes.GetNewPrimaryLocaleStatusResponse,
  ambassadorWixMultilingualLocalesV2LocaleTypes.GetNewPrimaryLocaleStatusResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMultilingualLocalesV2Locale.getNewPrimaryLocaleStatus(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/locale/change-primary',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setVisitorPrimaryLocale(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMultilingualLocalesV2LocaleUniversalTypes.SetVisitorPrimaryLocaleRequest,
  ambassadorWixMultilingualLocalesV2LocaleTypes.SetVisitorPrimaryLocaleRequest,
  ambassadorWixMultilingualLocalesV2LocaleUniversalTypes.SetVisitorPrimaryLocaleResponse,
  ambassadorWixMultilingualLocalesV2LocaleTypes.SetVisitorPrimaryLocaleResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMultilingualLocalesV2Locale.setVisitorPrimaryLocale(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/locale/set-visitor-primary',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  V2Locale as V2LocaleOriginal,
  LocaleVisibility as LocaleVisibilityOriginal,
  LocaleVisibilityWithLiterals as LocaleVisibilityWithLiteralsOriginal,
  UrlStructure as UrlStructureOriginal,
  UrlStructureWithLiterals as UrlStructureWithLiteralsOriginal,
  UrlStructureOverride as UrlStructureOverrideOriginal,
  CreateNewPrimaryLocalePayload as CreateNewPrimaryLocalePayloadOriginal,
  RawCreateLocaleRequest as RawCreateLocaleRequestOriginal,
  RawCreateLocaleResponse as RawCreateLocaleResponseOriginal,
  ChangeMainLocaleRequest as ChangeMainLocaleRequestOriginal,
  ChangeMainLocaleResponse as ChangeMainLocaleResponseOriginal,
  ForceDeleteLocaleRequest as ForceDeleteLocaleRequestOriginal,
  ForceDeleteLocaleResponse as ForceDeleteLocaleResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  ListSupportedLocalesRequest as ListSupportedLocalesRequestOriginal,
  ListSupportedLocalesResponse as ListSupportedLocalesResponseOriginal,
  SupportedLocale as SupportedLocaleOriginal,
  RegionOptions as RegionOptionsOriginal,
  InvalidateCache as InvalidateCacheOriginal,
  InvalidateCacheGetByOneOf as InvalidateCacheGetByOneOfOriginal,
  App as AppOriginal,
  Page as PageOriginal,
  URI as URIOriginal,
  File as FileOriginal,
  CustomTag as CustomTagOriginal,
  Pages as PagesOriginal,
  URIs as URIsOriginal,
  CreateLocaleRequest as CreateLocaleRequestOriginal,
  CreateLocaleResponse as CreateLocaleResponseOriginal,
  GetLocaleRequest as GetLocaleRequestOriginal,
  GetLocaleResponse as GetLocaleResponseOriginal,
  UpdateLocaleRequest as UpdateLocaleRequestOriginal,
  UpdateLocaleResponse as UpdateLocaleResponseOriginal,
  DeleteLocaleRequest as DeleteLocaleRequestOriginal,
  DeleteLocaleResponse as DeleteLocaleResponseOriginal,
  QueryLocalesRequest as QueryLocalesRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryLocalesResponse as QueryLocalesResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  BulkCreateLocalesRequest as BulkCreateLocalesRequestOriginal,
  BulkCreateLocalesResponse as BulkCreateLocalesResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkLocaleResult as BulkLocaleResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateLocalesRequest as BulkUpdateLocalesRequestOriginal,
  MaskedLocale as MaskedLocaleOriginal,
  BulkUpdateLocalesResponse as BulkUpdateLocalesResponseOriginal,
  BulkUpdateLocalesResponseBulkLocaleResult as BulkUpdateLocalesResponseBulkLocaleResultOriginal,
  BulkDeleteLocalesRequest as BulkDeleteLocalesRequestOriginal,
  BulkDeleteLocalesResponse as BulkDeleteLocalesResponseOriginal,
  BulkDeleteLocalesResponseBulkLocaleResult as BulkDeleteLocalesResponseBulkLocaleResultOriginal,
  CreateNewPrimaryLocaleRequest as CreateNewPrimaryLocaleRequestOriginal,
  CreateNewPrimaryLocaleResponse as CreateNewPrimaryLocaleResponseOriginal,
  GetNewPrimaryLocaleStatusRequest as GetNewPrimaryLocaleStatusRequestOriginal,
  GetNewPrimaryLocaleStatusResponse as GetNewPrimaryLocaleStatusResponseOriginal,
  GetNewPrimaryLocaleStatusResponseDataOneOf as GetNewPrimaryLocaleStatusResponseDataOneOfOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  FinishSuccessfulData as FinishSuccessfulDataOriginal,
  FinishWithErrorData as FinishWithErrorDataOriginal,
  SetVisitorPrimaryLocaleRequest as SetVisitorPrimaryLocaleRequestOriginal,
  SetVisitorPrimaryLocaleResponse as SetVisitorPrimaryLocaleResponseOriginal,
  MetaSiteSpecialEvent as MetaSiteSpecialEventOriginal,
  MetaSiteSpecialEventPayloadOneOf as MetaSiteSpecialEventPayloadOneOfOriginal,
  Asset as AssetOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCreatedContext as SiteCreatedContextOriginal,
  SiteCreatedContextWithLiterals as SiteCreatedContextWithLiteralsOriginal,
  Namespace as NamespaceOriginal,
  NamespaceWithLiterals as NamespaceWithLiteralsOriginal,
  SiteTransferred as SiteTransferredOriginal,
  SiteDeleted as SiteDeletedOriginal,
  DeleteContext as DeleteContextOriginal,
  DeleteStatus as DeleteStatusOriginal,
  DeleteStatusWithLiterals as DeleteStatusWithLiteralsOriginal,
  SiteUndeleted as SiteUndeletedOriginal,
  SitePublished as SitePublishedOriginal,
  SiteUnpublished as SiteUnpublishedOriginal,
  SiteMarkedAsTemplate as SiteMarkedAsTemplateOriginal,
  SiteMarkedAsWixSite as SiteMarkedAsWixSiteOriginal,
  ServiceProvisioned as ServiceProvisionedOriginal,
  ServiceRemoved as ServiceRemovedOriginal,
  SiteRenamed as SiteRenamedOriginal,
  SiteHardDeleted as SiteHardDeletedOriginal,
  NamespaceChanged as NamespaceChangedOriginal,
  StudioAssigned as StudioAssignedOriginal,
  StudioUnassigned as StudioUnassignedOriginal,
  SiteUrlChanged as SiteUrlChangedOriginal,
  SitePurgedExternally as SitePurgedExternallyOriginal,
  OdeditorAssigned as OdeditorAssignedOriginal,
  OdeditorUnassigned as OdeditorUnassignedOriginal,
  PicassoAssigned as PicassoAssignedOriginal,
  PicassoUnassigned as PicassoUnassignedOriginal,
  WixelAssigned as WixelAssignedOriginal,
  WixelUnassigned as WixelUnassignedOriginal,
  StudioTwoAssigned as StudioTwoAssignedOriginal,
  StudioTwoUnassigned as StudioTwoUnassignedOriginal,
  UserDomainMediaEnabled as UserDomainMediaEnabledOriginal,
  UserDomainMediaDisabled as UserDomainMediaDisabledOriginal,
  EditorlessAssigned as EditorlessAssignedOriginal,
  EditorlessUnassigned as EditorlessUnassignedOriginal,
  Empty as EmptyOriginal,
  SitePropertiesUpdated as SitePropertiesUpdatedOriginal,
  SitePropertiesEvent as SitePropertiesEventOriginal,
  Properties as PropertiesOriginal,
  Categories as CategoriesOriginal,
  Locale as LocaleOriginal,
  Address as AddressOriginal,
  AddressHint as AddressHintOriginal,
  PlacementType as PlacementTypeOriginal,
  PlacementTypeWithLiterals as PlacementTypeWithLiteralsOriginal,
  GeoCoordinates as GeoCoordinatesOriginal,
  BusinessSchedule as BusinessScheduleOriginal,
  TimePeriod as TimePeriodOriginal,
  DayOfWeek as DayOfWeekOriginal,
  DayOfWeekWithLiterals as DayOfWeekWithLiteralsOriginal,
  SpecialHourPeriod as SpecialHourPeriodOriginal,
  Multilingual as MultilingualOriginal,
  SupportedLanguage as SupportedLanguageOriginal,
  ResolutionMethod as ResolutionMethodOriginal,
  ResolutionMethodWithLiterals as ResolutionMethodWithLiteralsOriginal,
  ConsentPolicy as ConsentPolicyOriginal,
  DomainChangedEvent as DomainChangedEventOriginal,
  DomainChangedEventPayloadOneOf as DomainChangedEventPayloadOneOfOriginal,
  Registered as RegisteredOriginal,
  RegistrationCancelled as RegistrationCancelledOriginal,
  ConnectedToSite as ConnectedToSiteOriginal,
  DisconnectedFromSite as DisconnectedFromSiteOriginal,
  RegistrationExtended as RegistrationExtendedOriginal,
  OwnerChanged as OwnerChangedOriginal,
  PrivacyChanged as PrivacyChangedOriginal,
  ManagementTypeChanged as ManagementTypeChangedOriginal,
  BillingSubscriptionCancelled as BillingSubscriptionCancelledOriginal,
  ConnectionVerified as ConnectionVerifiedOriginal,
  ConnectionLost as ConnectionLostOriginal,
  ExpirationDateChanged as ExpirationDateChangedOriginal,
  PropagationStarted as PropagationStartedOriginal,
  VerificationStarted as VerificationStartedOriginal,
  ContactVerificationStatusChanged as ContactVerificationStatusChangedOriginal,
  ContactVerificationStatus as ContactVerificationStatusOriginal,
  ContactVerificationStatusWithLiterals as ContactVerificationStatusWithLiteralsOriginal,
  Expired as ExpiredOriginal,
  GraceEnded as GraceEndedOriginal,
  RedemptionEnded as RedemptionEndedOriginal,
  DnssecChanged as DnssecChangedOriginal,
  PriceIncreaseProcessed as PriceIncreaseProcessedOriginal,
  CreateNewPrimaryLocaleApplicationErrors as CreateNewPrimaryLocaleApplicationErrorsOriginal,
  SetVisitorPrimaryLocaleApplicationErrors as SetVisitorPrimaryLocaleApplicationErrorsOriginal,
} from './multilingual-locales-v2-locale-locales.types.js';
